import { getAuthToken } from '../services/auth/tokenStorage';
import AsyncStorage from '@react-native-async-storage/async-storage';

import { createLogger } from '../utils/logger';
const logger = createLogger('authDebug');

export const debugAuthStatus = async () => {
  try {
    const token = await getAuthToken();
    const user = await AsyncStorage.getItem('user');
    const hasLoggedIn = await AsyncStorage.getItem('hasLoggedIn');

    logger.debug('[Auth Debug] =================================');
    logger.debug('[Auth Debug] Has logged in:', hasLoggedIn);
    logger.debug('[Auth Debug] Token exists:', !!token);
    logger.debug('[Auth Debug] User exists:', !!user);
    logger.debug('[Auth Debug] =================================');

    return {
      hasToken: !!token,
      hasUser: !!user,
      hasLoggedIn: !!hasLoggedIn,
      token,
      user
    };
  } catch (error) {
    logger.error('[Auth Debug] Error checking auth status:', error);
    return null;
  }
};

export const clearAuthData = async () => {
  try {
    await AsyncStorage.removeItem('token');
    await AsyncStorage.removeItem('user');
    await AsyncStorage.removeItem('hasLoggedIn');
    logger.debug('[Auth Debug] All auth data cleared');
  } catch (error) {
    logger.error('[Auth Debug] Error clearing auth data:', error);
  }
};